import React from "react"
import PropTypes from "prop-types"
import styles from './Widget.module.less'

const WidgetPopup = ({ children, classes, ...props }) => (
  <div className={styles.widgetFrameInner}>
    {React.cloneElement(children, props)}
  </div>
)

WidgetPopup.propTypes = {
  children: PropTypes.node.isRequired,
  classes: PropTypes.object,
  theme: PropTypes.object
}

export default WidgetPopup
